import React from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import ContactCta from "../components/homi/ContactCta";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { useContact } from "../context/ContentContext";

export default function ContactPage() {
  const CONTACT = useContact();
  const mapQuery = encodeURIComponent(CONTACT.address || "");
  const cards = [
    { icon: Phone, title: "Call Us", lines: [CONTACT.phone], href: `tel:${CONTACT.phone}` },
    { icon: Mail, title: "Email Us", lines: [CONTACT.email], href: `mailto:${CONTACT.email}` },
    { icon: MessageCircle, title: "WhatsApp", lines: ["Message us anytime"], href: `https://wa.me/${CONTACT.whatsapp}` },
  ];
  return (
    <div className="App bg-white">
      <SiteHeader />
      <main>
        <PageBanner title="Contact Us" crumb="Contact" subtitle="Get in touch for a free, no-obligation quote on your next project." />

        <section className="py-20 lg:py-24 bg-homi-light">
          <div className="max-w-5xl mx-auto px-6 grid sm:grid-cols-3 gap-6">
            {cards.map((c) => {
              const Icon = c.icon;
              return (
                <a key={c.title} href={c.href} target={c.title === "WhatsApp" ? "_blank" : undefined} rel="noreferrer" className="block bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 rounded-2xl bg-homi-gold/15 flex items-center justify-center mx-auto mb-5">
                    <Icon className="w-8 h-8 text-homi-goldDark" />
                  </div>
                  <h3 className="font-heading font-bold text-lg text-homi-black mb-2">{c.title}</h3>
                  {c.lines.map((l) => <p key={l} className="text-homi-body text-sm leading-relaxed">{l}</p>)}
                </a>
              );
            })}
          </div>
        </section>

        <ContactCta />

        <section className="bg-white pb-0">
          <iframe
            title="EMB location - Croydon CR0 2EJ"
            src="https://www.openstreetmap.org/export/embed.html?bbox=-0.1100%2C51.3650%2C-0.0850%2C51.3800&layer=mapnik&marker=51.3728%2C-0.0982"
            className="w-full h-[420px] grayscale border-0"
            loading="lazy"
          />
          <div className="text-center py-4 bg-homi-light">
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
              target="_blank"
              rel="noreferrer"
              className="font-heading font-bold text-homi-goldDark hover:underline"
            >
              View {CONTACT.address} on Google Maps
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
